import React from 'react';
import Page from './Page';
import ContactForm from './ContactForm';

const langs = [
  'English', 'हिंदी (Hi)', 'తెలుగు (Te)', 'தமிழ் (Ta)', 'ಕನ್ನಡ (Kn)',
  'मराठी (Mr)', 'বাংলা (Bn)', 'ગુજરાતી (Gu)', 'മലയാളം (Ml)', 'ਪੰਜਾਬੀ (Pa)',
];

const PartnerPage = () => (
  <Page eyebrow="LET'S BUILD TOGETHER" title="Partner with iCraftz">
    <h2>What We Do</h2>
    <p>
      iCraftz transforms non-fiction book wisdom into structured, actionable
      insights delivered in 10 languages:
    </p>
    <p className="legal-langstrip">
      {langs.map((l, i) => (
        <span key={l}>{l}{i < langs.length - 1 ? ' | ' : ''}</span>
      ))}
    </p>

    <h2>How Authors Benefit</h2>
    <ul>
      <li>Your wisdom reaches vernacular readers who could never access your book in English.</li>
      <li>Every iCraftz insight card links back to buy your full book.</li>
      <li>Co-branded content reaching our growing audience.</li>
      <li>No cost to you — we handle all translation and technology.</li>
    </ul>

    <h2>How Publishers Benefit</h2>
    <ul>
      <li>New vernacular market activation across 10 languages.</li>
      <li>Data on which books resonate in which languages.</li>
      <li>Revenue sharing on affiliate sales.</li>
      <li>Co-branded vernacular editions possible.</li>
    </ul>

    <h2>Our Social Impact</h2>
    <p>
      India has 800M+ vernacular internet users. 95% of self-improvement
      content is in English only. iCraftz bridges that gap — one book, one
      language, one life at a time.
    </p>

    <h2>Licensing & Revenue Sharing</h2>
    <p>
      We are open to formal licensing arrangements, revenue sharing on
      affiliate sales, and co-creation of exclusive vernacular content.
    </p>

    <div className="legal-divider" />
    <h2>Get in Touch</h2>
    <p>Tell us a bit about yourself and we'll respond within 48 hours.</p>
    <ContactForm source="partner" includeOrganisation submitLabel="Get in Touch" />
  </Page>
);

export default PartnerPage;
